module.exports = __webpack_public_path__ + "media/Native_Artifactory_Integration_R3.cda2b5a8.mp4";